import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCog } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card } from '@themesberg/react-bootstrap';

export default () => {
  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h2 className="h4">Configuración</h2>
          <p className="mb-0">Administra la configuración del sistema.</p>
        </div>
      </div>

      <Row>
        <Col xs={12} lg={6}>
          <Card border="light" className="shadow-sm mb-4">
            <Card.Body>
              <div className="d-flex align-items-center">
                <div className="icon icon-shape icon-md icon-primary rounded me-4">
                  <FontAwesomeIcon icon={faUser} />
                </div>
                <div>
                  <h5 className="mb-1">Perfil de Usuario</h5>
                  <p className="mb-0 text-gray">Gestiona tu información personal</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} lg={6}>
          <Card border="light" className="shadow-sm mb-4">
            <Card.Body>
              <div className="d-flex align-items-center">
                <div className="icon icon-shape icon-md icon-secondary rounded me-4">
                  <FontAwesomeIcon icon={faCog} />
                </div>
                <div>
                  <h5 className="mb-1">Configuración General</h5>
                  <p className="mb-0 text-gray">Ajustes del sistema</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};